import MyTabs from '../../components/MyTabs';
import StaticWord from './StaticWord';

const GeneralStaticWords = () => {
    const tabs = [
        { id: "Basic", title: "Basic Static Word Info", Component: StaticWord },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralStaticWords;
